import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { apiCall, mediaUrl } from "../util";
import axios from "axios";
import { quotes } from "../Image";
const OurLeaders = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiCall + "leadership_team/getall");
        setData(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <section className="sg-li bg-sg-light-gradient half-section">
        <div className="container">
          <div className="row justify-content-center">
            {data.map((leader, index) => (
              <div className="col-lg-10" key={leader.id}>
                <div
                  // key={leader.id}
                  className="sg-img-radius bg-white overflow-hidden box-shadow-large"
                  style={{ marginBottom: "3%" }}
                >
                  <div className="row align-items-center">
                    <div className="col-lg-5">
                      <div className="pt-30px">
                        <ScrollAnimation
                          animateIn="animate__fadeInLeft"
                          animateOnce={true}
                          duration={1}
                        >
                          <img
                             src={`${mediaUrl}/${leader.image}`}
                            alt=""
                            className="-sg-img-radius h-100 object-fit-cover "  style={{height:"100%",width:"100%"}}
                          />
                        </ScrollAnimation>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="pe-30px">
                        <div className="d-flex gap-3 mb-20px">
                          <div>
                            <img
                               src={quotes}
                              className="w-80px"
                              alt=""
                            />
                          </div>
                          <div>
                            <span className="text-base-color fw-bold -mb-5px text-uppercase d-block fs-14">
                              {leader.designation}
                            </span>
                            <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                              {leader.name}
                            </h4>
                          </div>
                        </div>
                        <p className="fs-18 mb-0 lh-base mt-15px text-dark-gray">
                          "{leader.quote}"
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurLeaders;

















